import styled from '@emotion/styled';
import { SPACING, MEDIA_QUERY, ZINDEX } from '../../styles/emotion';

export const ToastsV2Container = styled.div`
  position: fixed;
  top: ${SPACING.XL};
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: ${ZINDEX.super + 1};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // This padding helps with toasts animating up when first child is removed;
  padding-top: ${SPACING.LG};

  ${MEDIA_QUERY.MOBILE} {
    width: 90%;
  }

  &:empty {
    padding-top: 0;
  }
`;
